import {boolean, route, string, union} from 'react-router-typesafe-routes';

export const publicRoutesPath = route({
  children: {
    accessDenied: route({
      path: 'access-denied',
      searchParams: {
        code: string().defined(),
      },
    }),
    emailUnsubscribe: route({
      path: 'unsubscribe-mess',
      searchParams: {
        md_email: string().defined(),
      },
    }),
    login: route({
      path: 'login',
      searchParams: {
        code: string(),
        eid: string(),
        isreg: string(),
        nat: string(), // no account type
      },
      state: {
        isFromPublicPage: boolean(),
      },
    }),
    widget: route({
      path: 'widget',
      searchParams: {
        eid: string(),
        hh: union(['1', '0']),
        pid: string(),
        slg: string(),
        tid: string(),
      },
    }),
    widgetBooking: route({
      path: 'widget/booking',
      searchParams: {
        eid: string().defined(),
        pid: string().defined(),
        tid: string().defined(),
      },
    }),
  },
});
